import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior() {
    //x代表横坐标，y代表纵坐标
    return { x: 0, y: 0 };
  },
  routes: [
    { path: '/', component: () => import("@/pages/newHome") },
    // { path: '/crash', component: () => import("@/pages/crash") },
    { path: '/pages/contract/contract', component: () => import("@/pages/swap") },
    { path: '/pages/trade/trade', component: () => import("@/pages/exchange") },
    { path: '/login', component: () => import("@/pages/login") },
    { path: '/findPwd', component: () => import("@/pages/FindPwd") },
    { path: '/register', component: () => import("@/pages/Register") },
    { path: '/help', component: () => import("@/pages/cms/Help") },
    { path: '/helplist', component: () => import("@/pages/cms/HelpList") },
    { path: '/helpdetail', component: () => import("@/pages/cms/HelpDetail") },
    { path: '/notice', component: () => import("@/pages/cms/Notice") },
    { path: '/about-us', component: () => import("@/pages/cms/AboutUs") },
    { path: '/option', component: () => import("@/pages/option") },
    { path: '/record', component: () => import("@/pages/subscribe/record") },
    { path: '/details', component: () => import("@/pages/subscribe/details") },
    { path: '/Purchase', component: () => import("@/pages/Purchase") },
    { path: '/adaDetails', component: () => import("@/pages/adaDetails") },
    { path: '/subscribe', component: () => (import("@/pages/subscribe")) },
    { path: '/announcement/:id', component: () => import("@/pages/announcement/NoticeItem"), name: "NoticeDetail" },
    { path: '/borrow/stepOne', component: () => import("@/pages/borrow/stepOne") },
    { path: '/borrow/bank', name: 'bank', component: () => import("@/pages/borrow/bank") },
    {
      path: '/uc', component: () => (import("@/pages/uc")),
      children: [{ path: '', component: () => (import("@/pages/uc/safe")) },
      { path: 'money', component: () => (import("@/pages/uc/money")) },
      { path: 'recharge', component: () => (import("@/pages/uc/recharge")) },
      { path: 'withdraw', component: () => (import("@/pages/uc/withdraw")) },
      { path: 'current', component: () => (import("@/pages/uc/current")), name: "NoticeDetail" },
      { path: 'history', component: () => (import("@/pages/uc/history")), name: "NoticeDetail" },
      { path: 'swapAssets', component: () => (import("@/pages/uc/swapAssets")), name: "NoticeDetail" },
      { path: 'record', component: () => (import("@/pages/uc/record")) },
      { path: 'contractflow', component: () => (import("@/pages/uc/contractflow")) },
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js